import TheProducts from '@/views/products/TheProducts';
import ProductsCreate from '@/views/products/create/ProductsCreate';

import ProductEdit from '@/views/products/edit/ProductEdit';
import ProductEditInfo from '@/views/products/edit/informations/ProductEditInfo';

import ProductCourse from '@/views/products/edit/course/ProductCourse';
import ProductCourseModuleDialog from '@/views/products/edit/course/ProductCourseModuleDialog';
import ProductCourseLessonDialog from '@/views/products/edit/course/ProductCourseLessonDialog';
import ProductCourseComments from '@/views/products/edit/course/ProductCourseComments';
import ProductCourseCommentDialog from '@/views/products/edit/course/ProductCourseCommentDialog';

import ProductFiles from '@/views/products/edit/files/ProductFiles';
import ProductFileDialog from '@/views/products/edit/files/ProductFileDialog';

import ProductLotes from '@/views/products/edit/lotes/ProductLotes';
import ProductLoteDialog from '@/views/products/edit/lotes/ProductLoteDialog';

import ShippingMethods from '@/views/products/edit/shipping/ShippingMethods';

import ProductEditCustomFields from '@/views/products/edit/customfields/ProductEditCustomField';
import CustomFieldsDialog from '@/views/products/edit/customfields/ProductCustomFieldsDialog';

import ProductOrderBumps from '@/views/products/edit/bumps/ProductOrderBumps';
import ProductOrderBumpDialog from '@/views/products/edit/bumps/ProductOrderBumpDialog';

import ProductEvents from '@/views/products/edit/events/ProductEvents';

import ProductEventsMautic from '@/views/products/edit/events/mautic/ProductEventDataMautic';
import ProductEventsMauticDialog from '@/views/products/edit/events/mautic/productEventMauticDialog'

import ProductEventsLeadlovers from '@/views//products/edit/events/leadlovers/ProductEventDataLeadlovers';
import ProductEventsLeadloversDialog from '@/views/products/edit/events/leadlovers/productEventLeadloversDialog'

import ProductEventsMex from '@/views/products/edit/events/mex/ProductEventDataMex';
import ProductEventsMexDialog from '@/views/products/edit/events/mex/productEventMexDialog'


export default [
    {
        name: 'products',
        path: '/products',
        component: TheProducts,
        meta: {
            requiresAuth: true,
            menuPage: 'products',
        },
    },
    {
        name: 'productCreateDefinestore',
        path: '/products/create',
        component: ProductsCreate,
        meta: {
            requiresAuth: true,
            menuPage: 'products',
        },
    },
    {
        name: 'productCreate',
        path: '/products/create/store=:id',
        component: ProductsCreate,
        meta: {
            requiresAuth: true,
            menuPage: 'products',
        }
    },
    { 
        name: 'product',
        path: '/products/:id/',
        component: ProductEdit,
        meta: {
            requiresAuth: true,
            menuPage: 'products',
        },
        children: [
            {
                name: 'productInfo',
                path: '/products/:id/',
                component: ProductEditInfo,
            },

            {
                name: 'productCourse',
                path: '/products/:id/course',
                component: ProductCourse,
                children: [
                    {
                        name: 'productCourseModulesCreate',
                        path: '/products/:id/course/modules/new',
                        component: ProductCourseModuleDialog,
                    },
                    {
                        name: 'productCourseModulesEdit',
                        path: '/products/:id/course/modules/:slug',
                        component: ProductCourseModuleDialog,
                    },

                    {
                        name: 'productCourseLessonsCreate',
                        path: '/products/:id/course/lessons/:slug/new',
                        component: ProductCourseLessonDialog,
                    },
                    {
                        name: 'productCourseLessonsEdit',
                        path: '/products/:id/course/lessons/:slug',
                        component: ProductCourseLessonDialog,
                    },
                ]
            },

            {
                name: 'productCourseComments',
                path: '/products/:id/course/comments',
                component: ProductCourseComments,
                children: [
                    {
                        name: 'productCourseCommentDialog',
                        path: '/products/:id/course/comments/:slug',
                        component: ProductCourseCommentDialog
                    }

                ]
            },

            {
                name: 'productFiles',
                path: '/products/:id/files',
                component: ProductFiles,
                children: [
                    {
                        name: 'productFileCreate',
                        path: '/products/:id/files/new',
                        component: ProductFileDialog
                    },
                    {
                        name: 'productFileEdit',
                        path: '/products/:id/files/:slug',
                        component: ProductFileDialog
                    }

                ]
            },

            {
                name: 'productOrderBumps',
                path: '/products/:id/bump',
                component: ProductOrderBumps,
                children: [
                    {
                        name: 'productOrderBumpCreate',
                        path: '/products/:id/bump/new',
                        component: ProductOrderBumpDialog,
                    },
                    {
                        name: 'productOrderBumpEdit',
                        path: '/products/:id/bump/:slug',
                        component: ProductOrderBumpDialog,
                    }

                ]
            },

            {
                name: 'productLotes',
                path: '/products/:id/lotes',
                component: ProductLotes,
                children: [
                    {
                        name: 'productLoteCreate',
                        path: '/products/:id/lotes/new',
                        component: ProductLoteDialog
                    },
                    {
                        name: 'productLoteEdit',
                        path: '/products/:id/lotes/:slug',
                        component: ProductLoteDialog
                    }
                ]
            },

            {
                name: 'productShippingMethods',
                path: '/products/:id/shipping-methods',
                component: ShippingMethods,
            },

            {
                name: 'productCustomFields',
                path: '/products/:id/custom-fields',
                component: ProductEditCustomFields,
                children: [
                    {
                        name: 'productCustomFieldsDialog',
                        path: '/products/:id/custom-fields/:slug',
                        component: CustomFieldsDialog,
                    }
                ]
            },

            {
                name: 'events',
                path: '/products/:id/events',
                component: ProductEvents,
                children: [
                    {
                        name: 'eventsMautic',
                        path: '/products/:id/events/mautic',
                        component: ProductEventsMautic,
                        children: [
                             {
                                name: 'mauticDialog',
                                path: '/products/:id/events/mautic/:slug',
                                component: ProductEventsMauticDialog,
                             }
                        ]
                    },

                    {
                        name: 'eventsLeadLovers',
                        path: '/products/:id/events/leadlovers',
                        component: ProductEventsLeadlovers,
                        children: [
                            {
                               name: 'leadLoversDialog',
                               path: '/products/:id/events/leadlovers/:slug',
                               component: ProductEventsLeadloversDialog,
                            }
                       ]
                    },

                    {
                        name: 'eventsMex',
                        path: '/products/:id/events/mex',
                        component: ProductEventsMex,
                        children: [
                            {
                               name: 'mexDialog',
                               path: '/products/:id/events/mex/:slug',
                               component: ProductEventsMexDialog,
                            }
                       ]
                    },
                ]
            },

        ]
    },
];